import { ReactNode, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const subDescription = "국내외 물류 전문 일신그룹";
const defaultLink = "https://morning.ilshingroup.com";
const defaultImage = "https://morning.ilshingroup.com/LOGO.jpg";

const titleMap = {
    www: "일신그룹",
    morning: "일신모닝택배",
    air: "일신항공해운",
    quick: "일신모닝퀵",
    express: "일신특송화물",
    ilshinconsole: "일신그룹관리자",
    console: "일신그룹관리자",
};
const knownSubs = Object.keys(titleMap);

const getTitle = (type: string) => titleMap[type as keyof typeof titleMap] || titleMap.morning;

type SeoProps = {
    type: string;
    pageTitle?: string;
};

export default function Seo({ type = "morning", pageTitle }: SeoProps) {
    const location = useLocation();
    const path = location.pathname;
    const pageUrl = `https://${type}.ilshingroup.com${path}`;

    const defaultTitle = `일신모닝택배 - ${subDescription}`;
    const OGUrl = pageUrl;

    const [title, setTitle] = useState(defaultTitle);

    const description = `${getTitle(type)} - 국내외 물류 전문 일신그룹! 국제특송·항공·전시화물부터 모닝택배·퀵까지 빠르고 정확한 Door to Door 서비스 제공합니다.`;

    useEffect(() => {
        const { host, port } = window.location;
        const parts = host.split(".");
        const sub = parts.length > 1 && parts[0] !== "localhost" ? parts[0] : "default";

        const isDevMode = parts.includes(`localhost:${port}`); // 개발모드
        const isDomainDevelop = parts.includes("likeweb"); // 개발운영모드

        const isDevelop = isDomainDevelop || isDevMode;
        const prefix = isDevelop ? "Dev " : "";

        const isKnownSub = knownSubs.includes(sub);
        const baseTitle = pageTitle
            ? `${pageTitle} - ${type ? getTitle(type) : "일신그룹"}`
            : isKnownSub
              ? `${getTitle(type)} - ${subDescription}`
              : `일신그룹 - ${subDescription}`;

        setTitle(`${prefix}${baseTitle}`);
    }, [type]);

    return (
        <Helmet>
            <meta charSet="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=no" />
            <title>{title}</title>
            {/* <link rel="canonical" href={defaultLink} /> */}
            <link rel="canonical" href={`https://${type}.ilshingroup.com`} />
            <meta name="description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={defaultImage} />
            <meta property="og:url" content={OGUrl} />
        </Helmet>
    );
}
